export enum Appearance {
    Legacy = 'legacy',
    Standard = 'standard',
    Fill = 'fill',
    Outline = 'outline'
}
